var _excluded = ["isDoubleNextHidden", "isDoublePrevHidden", "isNextHidden", "isPrevHidden", "prev", "next", "doubleNext", "doublePrev", "children", "type", "prefix", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@okee-uikit/react-utils';
import { usePrefixCls } from '@okee-uikit/react-config';
import { DoubleLeft, DoubleRight, Left, Right } from './../../../common/icons';
export function ViewNav(props) {
  var isDoubleNextHidden = props.isDoubleNextHidden,
      isDoublePrevHidden = props.isDoublePrevHidden,
      isNextHidden = props.isNextHidden,
      isPrevHidden = props.isPrevHidden,
      prev = props.prev,
      next = props.next,
      doubleNext = props.doubleNext,
      doublePrev = props.doublePrev,
      children = props.children,
      type = props.type,
      prefix = props.prefix,
      className = props.className,
      extra = _objectWithoutProperties(props, _excluded);

  var cls = classnames(usePrefixCls(prefix, _defineProperty({
    nav: true
  }, type, true), true), className);
  var prevCls = usePrefixCls(prefix, _defineProperty({
    'nav-prev': true
  }, type, true), true);
  var centerCls = usePrefixCls(prefix, _defineProperty({
    'nav-center': true
  }, type, true), true);
  var nextCls = usePrefixCls(prefix, _defineProperty({
    'nav-next': true
  }, type, true), true);
  return React.createElement("div", _objectSpread({
    className: cls
  }, extra), React.createElement("div", {
    className: prevCls
  }, !isDoublePrevHidden && doublePrev != null ? React.createElement(DoubleLeft, {
    onClick: doublePrev,
    size: 18
  }) : null), React.createElement("div", {
    className: prevCls
  }, !isPrevHidden && prev != null ? React.createElement(Left, {
    onClick: prev,
    size: 18
  }) : null), React.createElement("div", {
    className: centerCls
  }, children), React.createElement("div", {
    className: nextCls
  }, !isNextHidden && next != null ? React.createElement(Right, {
    onClick: next,
    size: 18
  }) : null), React.createElement("div", {
    className: nextCls
  }, !isDoubleNextHidden && doubleNext != null ? React.createElement(DoubleRight, {
    onClick: doubleNext,
    size: 18
  }) : null));
}